import React from "react"
import {Dispatch} from "redux"
import {connect} from "react-redux"

// Actions
import * as a from "../store/actions"

// Models
import {RootState} from "../../../models"
import {AuthStateType, SignInCredentials} from "../models"

// Selectors
import {selectSignInErrorMessage, selectSigningIn} from "../store/selectors"

/**
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
    signingIn: selectSigningIn(state),
    signInErrorMessage: selectSignInErrorMessage(state),
});

/**
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
    signIn: (credentials: SignInCredentials) => dispatch(a.signInAsync.request(credentials)),
});

/**
 * @param BaseComponent
 */
export default function withSignIn(BaseComponent: React.ComponentType<any>) {
    return connect(mapStateToProps, mapDispatchToProps)(BaseComponent)
}

export type WithSignInProps = {
    signingIn: boolean
    signInErrorMessage: AuthStateType["signInError"]
    signIn(credentials: SignInCredentials): void
}
